module.exports = __webpack_public_path__ + "img/buy.e0b4ec72.png";